// @flow
import { combineReducers } from 'redux';

import label from './label/label.reducer';
import { isNavigation } from './navigation/navigation.reducer';
import shouldDisplay from './should-display/shouldDisplay.reducer';

export default combineReducers({
  isNavigation,
  label,
  shouldDisplay,
});
